import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ClientViewOverviewTab from 'react/member/card/components/client_view/ClientViewOverviewTab';
import ErrorBoundary from 'react/shared/components/ErrorBoundary';
import PALETTE from 'react/shared/theme/palette';

export default function ClientViewTabs({ personId }) {
  const tabs = [{ id: 'overview_tab_link', label: 'Overview', display: true }];

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <ErrorBoundary>
      <Box sx={{ outline: `1px solid ${PALETTE.grey5}` }} />
      <Box sx={{ maxWidth: '940px', margin: '0 auto' }}>
        <TabContext value={activeTab}>
          <Tabs
            id="client-view-nav-tabs"
            indicatorColor="primary"
            onChange={handleTabChange}
            scrollButtons
            sx={{
              borderBottom: `1px solid ${PALETTE.grey5}`,
              '& .MuiTabs-scrollButtons.Mui-disabled': {
                display: 'none',
              },
            }}
            textColor="primary"
            value={activeTab}
            variant="scrollable"
          >
            {tabs.map(
              (tab) =>
                tab.display && (
                  <Tab
                    id={tab.id}
                    key={tab.id}
                    label={tab.label}
                    sx={{
                      marginTop: '10px',
                      minWidth: '130px',
                      textTransform: 'capitalize',
                      fontSize: '18px',
                    }}
                    value={tab.id}
                  />
                ),
            )}
          </Tabs>

          <TabPanel value="overview_tab_link">
            <ClientViewOverviewTab accountId={personId} />
          </TabPanel>
        </TabContext>
      </Box>
    </ErrorBoundary>
  );
}

ClientViewTabs.propTypes = {
  personId: PropTypes.string,
};
